import { createSlice } from "@reduxjs/toolkit";
import { useAppSelector } from "../store";

// NOTE: This will put the frontend only in maintenance mode and should not be changed.
const initialState = {
  authcontroller: true,
  tradecontroller: true,
  targetorderscontroller: true,
  depositcontroller: true,
  withdrawalcontroller: true,
  pricealertcontroller: true,
  reportingcontroller: true,
};

const MaintenanceSlice = createSlice({
  name: "maintenance",
  initialState,
  reducers: {
    setMaintenanceStatus(state, action) {
      return action.payload;
    },
  },
});

export const useMaintenanceState = () => useAppSelector((state) => state.maintenance);

export const { setMaintenanceStatus } = MaintenanceSlice.actions;
export default MaintenanceSlice;
